import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { buildMechanismDrawerMetricCollapsibleGroups } from '../../../../utils/electronicsDashboardUtils';
import { MetricCollapsibleDrawerSection, type MotorDrawerSectionProps } from '../DrawerDraggableLayout';

const MechanismDrawerSection = ({ motorPorts, projectCode }: MotorDrawerSectionProps) => {
  const { t } = useTranslation();

  const metricGroups = useMemo(
    () => buildMechanismDrawerMetricCollapsibleGroups(motorPorts, projectCode, (key, defaultValue) => t(key, defaultValue)),
    [motorPorts, projectCode, t]
  );

  return <MetricCollapsibleDrawerSection groups={metricGroups} />;
};

export default MechanismDrawerSection;
